import React from 'react';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { VisualPicker } from '../../../CommonComponents/OPL/VisualPicker/VisualPicker';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { BeFi20Props, useBeFi20 } from './useBeFi20';

const HEADER_ID = 'pdf--edit-befi20-modal--header';
const FORM_ID = 'pdf--edit-befi20-modal--form';

export const BeFi20 = (props: BeFi20Props) => {
  const {
    data: { comparisons },
    onClose,
  } = props;

  const { fields, setValue, onSubmit } = useBeFi20(props);

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      aria={{ labelledby: HEADER_ID }}
      shouldCloseOnOverlayClick={false}
    >
      <ModalHeader as="h2" id={HEADER_ID}>
        Choose BeFi20 Comparison
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody id={FORM_ID} as="form" onSubmit={onSubmit}>
        <Text as="p" color="neutral.500">
          Select the specific comparison result(s) you would like to show in the PDF
        </Text>

        {fields.map((field, index) => {
          return (
            <VisualPicker
              key={field.key}
              variant="checkbox"
              label={comparisons[index].name}
              helperText={`${comparisons[index].similarity} Similarity`}
              checked={field.selected}
              onChange={evt => setValue(`comparisonFields.${index}.selected`, evt.target.checked)}
              mt="8"
            />
          );
        })}
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button type="submit" form={FORM_ID} ml="8">
          Save Changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
